import s from './index.module.scss';
import i2 from './i3.module.scss';
//import i2 from './i2.module.scss';
import { loaderPostFetch, csAmount } from './util';

import Notif from '../../components/notif';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';
import { Entry } from './Statements';
import { useState, useEffect } from 'react';
import InfoUser from './info/index';
 

export function Entry2({ data, currency }) {
  function h(n) {
    let y = n.replace('_', ' ');
    return y;
  }  
  return (
    <>
      <Link to={`dashboard/receipt/${data?.ref2}`} className={i2.titem}>
          <div className={i2.img}>
            <img src={`syms/${data?.transaction_type}.svg`} />
          </div>
        <div className={i2.others}>
          <div>
          <div className={i2.r1}>
            <div className={i2.titl}> {data?.name} </div> 
            <div className={`${i2.amount} ${i2[data?.transaction_type]}`}>
              {data?.transaction_type == 'credit' ? `+${currency}` : `-${currency}`}
              {data?.amount ? csAmount(data?.amount) : '0.00'}
            </div>
          </div>
          <div className={i2.r1}>
            <div className={i2.dtitl}> {data?.date} </div> 
            <div className={i2[data?.status]}>{h(data?.status)}</div>
          </div>
          </div>
        </div>
      </Link> 
    </>
  );
}

export async function itloader({ params }) {
  const formData = new FormData();
  formData.append('getinstituition', 'getinstituition');

  let tok = window.localStorage.getItem('baUid');
  if (tok != null) {
    formData.append('token', tok);
  }

  const res = await loaderPostFetch(`api/users.php`, formData);

  const formData2 = new FormData();
  formData2.append('getstatement2', 'getstatement2');
  if (tok != null) {
    formData2.append('token', tok);
  }
  const res2 = await loaderPostFetch(`api/users.php`, formData2);


  const formData3 = new FormData();
  formData3.append('pincheck', 'pincheck');
  if (tok != null) {
    formData3.append('token', tok);
  }
  const pincheck = await loaderPostFetch(`api/users.php`, formData3); 


  //const sessions = await getfetch(`${apiUrl}/sessionlist`, {});
  return { ...params, ...res2, ...res, ...pincheck };
}

export default function DashboardIndex() {
  //list ttransactions

  const [n, sN] = useState({ display: false, type: 'success', msg: '' });

  const { data, u, transactions, currency, tb, haspin, details } = useLoaderData();

  const [disAmount, sDisAmount] = useState();

  const na=()=>{

    sN({ display: true, type: 'error', msg: 'Not Available in your region' });
   
    setTimeout(() => {
      sN({ display: false, type: 'success', msg: `` }); 
    }, 5000);
  }

  const [greeting, sGreeting] = useState();
  useEffect(() => {
    let y = window.localStorage.getItem('displayAmount');
    sDisAmount(y);

    var data = [
        [0, 4, "Greetings!"], 
        [5, 11, "Greetings!"],          //Store messages in an array
        [12, 17, "Greetings!"],
        [18, 24, "Greetings!"]
    ],
        hr = new Date().getHours();

      for(var i = 0; i < data.length; i++){
          if(hr >= data[i][0] && hr <= data[i][1]){
              //console.log(data[i][2]);
              sGreeting(data[i][2]);
          }
      }

  }, []);
  useEffect(() => {
    if (disAmount) {
      window.localStorage.setItem('displayAmount', disAmount);
    }
  }, [disAmount]);

  useEffect(()=>{
    if (typeof haspin!='undefined') {
      if (!haspin) {
        window.location.href="dashboard/pincreation";
      }
    }
  },[haspin]);

 

  return (
    <>
      <Notif display={n?.display} type={n?.type} msg={n?.msg} />
      <>{(typeof details=='undefined')?

      <><div>
        <div className={i2.b3} >
          <div className={i2.box1}>
            <div className={i2.img}>
            {u?.picture ? <img src={`/wp-user/uploads/${u?.picture}`} /> : null}
            </div>
            <div className={i2.coll2}>
              <div className={i2.leftt}>
                <div className={i2.greeting}>{greeting}
                </div>
                <div className={i2.name}>{u.fullname}
                </div>
              </div>
              <div className={i2.rightt}>
                <div className={i2.an}>Account Number
                </div>
                <div className={i2.thean}>{data?.account_no}
                </div>
              </div>
            </div>
          </div>

          <div className={i2.box2}>
              <div className={i2.leftt}>Available Balance
              </div>
              <div className={i2.rightt}>
                <div className={i2.headd}>Account Status
                </div>
                <div className={i2.vall}> {u?.current_plan||'Tier 1'}
                </div>
              </div>
          </div>

          <div className={i2.box3}>
          <>{`${currency}${tb?.current_balance ? csAmount(tb?.current_balance) : '0.00'}`}</>
          </div>

          <div className={i2.pat}><img src="pattern.svg" /></div>
        </div>
      </div>


      <div className={i2.d2con}>

        <div className={i2.d2}>
          <div className={i2.item} onClick={()=>{
            window.location.href = `dashboard/send`;
          }}>
            <img src="syms/up.svg" />
            <div className={i2.hint}>Send</div>
          </div>
          <div className={i2.item} onClick={()=>{
            window.location.href = `dashboard/add-funds/it`;
          }}>
            <img src="syms/down.svg" />
            <div className={i2.hint}>Receive</div>
          </div>
          <div className={i2.item} onClick={na}>
            <img src="syms/dols.svg" />
            <div className={i2.hint}>Loan</div>
          </div>
          <div className={i2.item} onClick={()=>{
            window.location.href = `dashboard/add-funds`;
          }}>  
            <img src="syms/load.svg" />
            <div className={i2.hint}>Topup</div>
          </div>
        </div>

      </div>

      <div className={i2.d3}>
        <div className={i2.item}>
          <div className={i2.r2}>
            <div className={i2.title}>Total Credit</div>
            <div className={i2.credit}>{u?.total_credit}</div>
          </div>
          <div>
          {<img src="syms/stat.svg" />}
          </div>
        </div>
        <div className={i2.item}>
          <div className={i2.r2}>
            <div className={i2.title}>Total Debit</div>
            <div className={i2.debit}>{u?.total_debit}</div>
          </div>
          <div>
          {<img src="syms/grab.svg" />}
          </div>
        </div>
      </div>
 

      <div className={i2.d4}>
        <div className={i2.r1}>
          <div className={i2.head}>
          Recent Transactions
          </div>
          <img src="syms/more.svg" />
        </div>

        {!transactions || transactions?.length == 0 ? (
          <div className={s.empty}>
            <div className={s.c}>
              <div className={s.h}>No Transaction History</div>
              <div className={s.s}>
                Your recent transaction should appear here contact
                <br /> support for any issues
              </div>
            </div>
          </div>
        ) : (
          <>
            {transactions ? (
              <>
                <div className={s.s}>&nbsp;</div>
                {transactions?.map((n, i) => {
                  return <Entry2 data={n} key={i} currency={currency} />;
                })}
              </>
            ) : null}
          </>
        )}

      </div>
      </>

      :<InfoUser state={details} />}</>

 
    </>
  );
}

export const DashboardR3={
      index: true,
      element: <DashboardIndex />,
      loader: itloader,
    }